import { connect } from 'react-redux'
import Navigation from './Navigation'

const mapStateToProps = state => {
    return {
        roles: state.profile.roles
    }
}

export default connect(mapStateToProps)(Navigation)
